
import { apiConnector } from "../apiConnector";
import { teacherAnalysisEndpoints } from "../apis";

const { GET_ALL_TEACHER_ANLYSIS_API, GET_TEACHER_ANALYSIS_API } = teacherAnalysisEndpoints;

// Fetch all teacher analyses
export function getAllTeacherAnalyses() {
  console.log("api",GET_ALL_TEACHER_ANLYSIS_API)
  return async () => {
    

    try {
      // const toastId = toast.loading("Loading teacher analyses...");

      const response = await apiConnector("GET", GET_ALL_TEACHER_ANLYSIS_API);
      console.log("data",response)
      // toast.success("Teacher analyses loaded successfully");
      return response.data;
    } catch (error) {
      console.error("GET ALL TEACHER ANALYSES ERROR:", error);
      // toast.error("Failed to load teacher analyses");
      return [];
    } finally {
      // toast.dismiss(toastId);
    }
  };
}

// Fetch single teacher analysis by teacherId
export function getTeacherAnalysisById(teacherId) {
  return async () => {
   

    try {
      // const toastId = toast.loading("Loading teacher analysis...");

      const response = await apiConnector(
        "GET",
        `${GET_TEACHER_ANALYSIS_API}/${teacherId}`,

      );
console.log("data",response)
      // toast.success("Teacher analysis loaded successfully");
      return response.data;
    } catch (error) {
      console.error("GET TEACHER ANALYSIS ERROR:", error);
      // toast.error("Failed to load teacher analysis");
      return null;
    } finally {
      // toast.dismiss(toastId);
    }
  };
}
